import { AppStyles } from '../app-context-provider';
import { CSSProperties } from 'react';

export enum ColorType {
  dark,
  light,
  muted,
  vibrant,
}

export function buttonStyle(
  styles: AppStyles | null,
  type: ColorType
): CSSProperties {
  let style: CSSProperties;
  switch (type) {
    case ColorType.dark:
      style = {
        backgroundColor: styles?.buttonColors.dark,
        color: styles?.buttonColors.light,
      };
      break;
    case ColorType.light:
      style = {
        backgroundColor: styles?.buttonColors.light,
        color: styles?.buttonColors.dark,
      };
      break;

    case ColorType.muted:
      style = {
        backgroundColor: styles?.buttonColors.vibrant,
        color: styles?.buttonColors.dark,
      };
      break;

    case ColorType.vibrant:
      style = {
        backgroundColor: styles?.buttonColors.muted,
        color: styles?.buttonColors.dark,
      };
      break;
    default:
      style = {};
  }

  style.textDecoration = 'none';
  style.border = 'none';
  style.padding = '0.75em 1.5em';
  style.cursor = 'pointer';
  style.fontWeight = 'bold';

  return style;
}

export function backgroundStyle(
  styles: AppStyles | null,
  type: ColorType
): CSSProperties {
  let style: CSSProperties;
  switch (type) {
    case ColorType.dark:
      style = {
        backgroundColor: styles?.background.dark,
        color: styles?.bodyText.light,
      };
      break;
    case ColorType.light:
      style = {
        backgroundColor: styles?.background.light,
        color: styles?.bodyText.dark,
      };
      break;

    case ColorType.muted:
      style = {
        backgroundColor: styles?.background.vibrant,
        color: styles?.bodyText.muted,
      };
      break;

    case ColorType.vibrant:
      style = {
        backgroundColor: styles?.background.muted,
        color: styles?.bodyText.vibrant,
      };
      break;
    default:
      style = {};
  }

  return style;
}

export function rounded(): CSSProperties {
  return {
    borderRadius: '15px',
  };
}

export function shadow(styles: AppStyles | null): CSSProperties {
  return {
    boxShadow: 'rgb(0, 0, 0, 15%) 10px 10px 50px 0px',
  };
}
